import { Directive, inject } from '@angular/core';
import { CryptoOnboardingFacade } from '@zero/self-service/domain';
import { timer } from 'rxjs';

@Directive()
export class SuccessInfoPageBase {
  public cryptoOnboardingFacade = inject(CryptoOnboardingFacade);

  public init() {
    this.cryptoOnboardingFacade.loadOnboardingStatus();
    timer(5000).subscribe(() => {
      // reload again in case wallet has been created meanwhile
      this.cryptoOnboardingFacade.loadOnboardingStatus();
    });
  }
}
